module.exports = `${require.publicPath}avatar.a1f8e6e5.png`;